import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { EmptyTab } from '../../../components/styled/EmptyTab';
import { useTranslation } from '../../../../../../i18n/useTranslation';

export type Props = {
    message?: string;
    readOnly?: boolean;
    onClickAddQuery: () => void;
};

export default function EmptyQueries({ message, readOnly = false, onClickAddQuery }: Props) {
    const { t } = useTranslation();
    return (
        <EmptyTab tab="queries">
            {!readOnly && !message && (
                <Button onClick={onClickAddQuery} aria-label={t('Add Query')}>
                    <PlusOutlined aria-hidden="true" /> {t('Add Query')}
                </Button>
            )}
        </EmptyTab>
    );
}
